export default (phone) => {
    return phone.replace(/[-()\+]/g,'')
};
